import classNames from 'classnames';
import { ReactElement } from 'react';
import { S_Checkbox } from '../../design/inputs/checkbox/S_Checkbox';
import { S_FieldLabel } from '../../design/labels/fieldLabel/S_FIeldLabel';
import { RowLayout } from '../../modules/common/layouts/rowLayout/RowLayout';

interface ICheckboxMultiSelectProps<T> {
  label?: string;
  options: T[];
  values: T[];
  valueField: keyof T;
  labelField: keyof T;
  onSelectChange: (selected: T[]) => void;
  className?: string;
}

export const CheckboxMultiSelect = <T,>(props: ICheckboxMultiSelectProps<T>): ReactElement => {
  const { valueField, values, labelField, options, label, className, onSelectChange } = props;

  const handleClick = (selected: T): void => {
    const output = values.slice();
    const element = output.find((o) => o[valueField] === selected[valueField]);
    const index = element ? output.indexOf(element) : -1;
    if (index < 0) {
      output.push(selected);
    } else {
      output.splice(index, 1);
    }
    onSelectChange(output);
  };

  return (
    <RowLayout
      size='md'
      className={classNames('checkbox-multi-select', className)}
    >
      {label && <S_FieldLabel>{label}</S_FieldLabel>}
      {options.map((o) => (
        <S_Checkbox
          id={`${o[valueField]}-custom-input`}
          className='checkbox-multiselect-item'
          key={`${o[valueField]}`}
          checked={values.some((x) => x[valueField] === o[valueField])}
          label={<>{o[labelField]}</>}
          disabled={false}
          readOnly={true}
          onClick={(): void => {
            handleClick(o);
          }}
        />
      ))}
    </RowLayout>
  );
};
